import React from 'react'

const NotesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.2026 12.6672L1.83594 10.3005L2.76927 9.36719L4.18594 10.7839L7.01927 7.95052L7.9526 8.90052L4.2026 12.6672ZM4.2026 7.33385L1.83594 4.96719L2.76927 4.03385L4.18594 5.45052L7.01927 2.61719L7.9526 3.56719L4.2026 7.33385ZM9.16927 11.3339V10.0005H15.1693V11.3339H9.16927ZM9.16927 6.00052V4.66719H15.1693V6.00052H9.16927Z'
      fill='currentColor'
    />
  </svg>
)

export default NotesIcon
